import { createAction, props } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";
import { PropertyDTO } from "src/app/models/Properties/propertyDTO";

export const getPropertiesList = createAction(
  "[Properties] Get All Properties List Action",
  props<{ options: any }>()
); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadPropertiesList = createAction(
  "[Properties] Load All Properties List Action",
  props<{ response: any[] }>()
);
export const getExcelPropertiesList = createAction(
  "[Properties] Get All Properties Excel List Action",
  props<{ options: any }>()
); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadExcelPropertiesList = createAction(
  "[Properties] Load All Properties Excel List Action",
  props<{ response: any[] }>()
);
export const getPropertiesUsagesList = createAction(
  "[Properties] Get All Property Usages List Action",
  props<{ pageReq: PaginationRequest }>()
); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadPropertiesUsagesList = createAction(
  "[Properties] Load All Property Usages List Action",
  props<{ response: any[] }>()
);
export const getPropertiesDataTypeList = createAction(
  "[Properties] Get All Property Data Types List Action",
  props<{ pageReq: PaginationRequest }>()
); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadPropertiesDataTypeList = createAction(
  "[Properties] Load All Property Data Types List Action",
  props<{ response: any[] }>()
);
// Table Configuration Settings
export const getPropertiesTableConfig = createAction(
  "[Properties] Get Properties Table Configuration Action",
  props<{ options: any }>()
);
export const loadPropertiesTableConfig = createAction(
  "[Properties] Load Properties Table Configuration Action",
  props<{ response: any[] }>()
);
export const savePropertiesTableConfig = createAction(
  "[Properties] Save Properties Table Configuration Action",
  props<{ config: any }>()
);
export const updateProperty = createAction(
  "[Properties] Update Property Action",
  props<{ property: PropertyDTO }>()
);
export const createProperty = createAction(
  "[Properties] Create Property Action",
  props<{ property: PropertyDTO }>()
);
export const deleteProperty = createAction(
  "[Cards] Delete Card Prompt Action ",
  props<{ propertyCode: string }>()
);
export const getProperty = createAction(
  "[Properties] Get a Property by code Action",
  props<{ code: string }>()
);
export const getPropertiesFilteredList = createAction(
  "[Properties] Get All Filtered Properties List Action",
  props<{ options: any }>()
);
export const loadPropertiesFilteredList = createAction(
  "[Properties] Load All Filtered Properties List Action",
  props<{ response: any[] }>()
);
export const setEnabled = createAction(
  "[Properties] Set Enabled Action",
  props<{ property: PropertyDTO }>()
);
export const setDisabled = createAction(
  "[Properties] Set Disabled Action",
  props<{ property: PropertyDTO }>()
);
export const setProperty = createAction(
  "[Properties] Set Property party Action",
  props<{ property: any }>()
);
export const resetProperty = createAction(
  "[Properties] Reset Property party Action"
);
export const resetCreation = createAction("[Properties] Reset Creation Action");
//Loading
export const resetPropertiesState = createAction(
  "[Properties] Reset Properties State Action"
);
export const getLoadingState = createAction(
  "[Properties] Get Properties Loading State Action"
);
export const setLoadingStartState = createAction(
  "[Properties] Set Properties Loading Start State Action"
);
export const setLoadingEndState = createAction(
  "[Properties] Set Properties Loading End State Action"
);
